import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const fetchPlacedCompanyStudentsCount = createAsyncThunk('fetchPlacedCompanyStudentsCount', async (obj, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/reports/students-placed-company?year=${obj.year}`);
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const placedCompanyStudentsSlice = createSlice({
    name: 'studentPlacedCount',
    initialState: {
        loading: false,
        placedStudentsPerCompany: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPlacedCompanyStudentsCount.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchPlacedCompanyStudentsCount.fulfilled, (state, action) => {
            state.loading = false;
            state.placedStudentsPerCompany = action.payload
        })
        builder.addCase(fetchPlacedCompanyStudentsCount.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default placedCompanyStudentsSlice.reducer